/**
 * Hook for fetching orders
 */
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/lib/api-client';

export interface OrderItem {
    order_id: string;
    order_code: string;
    receiver_company_id: string | null;
    shipper_company_id: string | null;
    container_id: string | null;
    order_status: string;
    target_week: string | null;
    notes: string | null;
    total_value_usd: number | null;
    currency: string;
    created_at: string;
}

export interface OrdersResponse {
    orders: OrderItem[];
    skip: number;
    limit: number;
    count: number;
}

/**
 * Hook to fetch orders for the current company
 */
export function useOrders(enabled = true) {
    return useQuery({
        queryKey: ['orders'],
        queryFn: async (): Promise<OrdersResponse> => {
            return apiGet<OrdersResponse>('/orders?limit=100');
        },
        enabled,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
}
